"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarrierType = exports.InboundStatus = exports.ShipmentType = void 0;
var ShipmentType;
(function (ShipmentType) {
    ShipmentType["FLOOR_LOADED_CONTAINER"] = "FLOOR_LOADED_CONTAINER";
    ShipmentType["PALLETIZED"] = "PALLETIZED";
})(ShipmentType || (exports.ShipmentType = ShipmentType = {}));
var InboundStatus;
(function (InboundStatus) {
    InboundStatus["IN_DRAFT"] = "IN_DRAFT";
    InboundStatus["READY_TO_SHIP"] = "READY_TO_SHIP";
    InboundStatus["RECEIVING"] = "RECEIVING";
    InboundStatus["COMPLETE"] = "COMPLETE";
    InboundStatus["UNKNOWN"] = "UNKNOWN";
    InboundStatus["CREATED"] = "CREATED";
})(InboundStatus || (exports.InboundStatus = InboundStatus = {}));
var CarrierType;
(function (CarrierType) {
    CarrierType["DELIVERR"] = "DELIVERR";
    CarrierType["OTHER"] = "OTHER";
})(CarrierType || (exports.CarrierType = CarrierType = {}));
//# sourceMappingURL=StorageInboundRequest.js.map